/**
 * Shared helpers for formatting human-readable, zero-padded entity IDs
 * for display (e.g. `ORD-000123`). Centralizes the `padStart` pattern that
 * used to be duplicated inline across many pages.
 *
 * Note: these are purely client-side display formatters for raw numeric
 * IDs. They must NOT be used for fields the backend already formats and
 * returns as a string (e.g. `invoice_number`) — use that value as-is.
 */

const pad = (id: number | string): string => String(id).padStart(6, '0');

/** e.g. formatOrderId(123) -> 'ORD-000123' */
export const formatOrderId = (id: number | string): string => `ORD-${pad(id)}`;

/** e.g. formatRouteId(7) -> 'RT-000007' */
export const formatRouteId = (id: number | string): string => `RT-${pad(id)}`;

/** e.g. formatPaymentId(45) -> 'PAY-000045' */
export const formatPaymentId = (id: number | string): string => `PAY-${pad(id)}`;

/** e.g. formatInvoiceId(9) -> 'INV-000009' (only for a raw numeric id, not a backend-formatted invoice_number) */
export const formatInvoiceId = (id: number | string): string => `INV-${pad(id)}`;

/** e.g. formatDeliveryId(3) -> 'DEL-000003' */
export const formatDeliveryId = (id: number | string): string => `DEL-${pad(id)}`;
